import { Injectable } from '@angular/core';
import { config } from '@tag/graphql';
import type { CommentSheet, GraphQLParams } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';

export interface Response {
  comments: { items: CommentSheet[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class CommentsGQL extends Query<Response, GraphQLParams<'commentSheet'>> {
  document = gql(config.commentSheet.query);
}
